import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom'; 
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './App.css';

import Main from './Main/Main';
import Notice from './Page/Notice';
import Performance from './Page/Performance';
import Map from './Page/Map';
import BoothInfo from './Page/BoothInfo';
import AndBooth from './Booth/And_Booth';
import CinderellaBooth from './Booth/Cinderella_Booth';
import JujeomBooth from './Booth/Jujeom_Booth';
import SteBooth from './Booth/Ste_Booth';
import CenterStage1 from './Performance/CenterStage1';
import CenterStage2 from './Performance/CenterStage2';
import Streetstage from './Performance/Street_stage';
import Menu1 from './Booth/jujeom/menu1';

function App() {
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const setAppHeight = () => {
      document.querySelector('.App').style.height = `${window.innerHeight}px`;
    };

    setAppHeight();
    window.addEventListener('resize', setAppHeight);

    return () => window.removeEventListener('resize', setAppHeight);
  }, []);

  return (
    <div className="App">
      
      <TransitionGroup className="transition-group">
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Routes location={location}>
            <Route path="/" element={<Main />} />
            <Route path="/notice" element={<Notice />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/map" element={<Map />} />
            <Route path="/booth-info" element={<BoothInfo />} />
            <Route path="/and-booth" element={<AndBooth />} />
            <Route path="/cinderella-booth" element={<CinderellaBooth />} />
            <Route path="/jujeom-booth" element={<JujeomBooth />} />
            <Route path="/ste-booth" element={<SteBooth />} />
            <Route path="/centerstage1" element={<CenterStage1 />} />
            <Route path="/centerstage2" element={<CenterStage2 />} />
            <Route path="/streetstage" element={<Streetstage />} />
            <Route path="/menu1" element={<Menu1 />} />
          </Routes>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}

export default App;
